import React from 'react';
import { routePaths } from 'components/Routes/data';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AddEditBankAccount } from './AddEditBankAccount';
import { PreviewBankAccount } from './PreviewBankAccount';
import { useIsViewEditBankAccountAllowed } from './hooks/useIsViewEditBankAccountAllowed';
import { FormProvider } from 'forms/FormContext';
import { bankFormDataInitialState } from './data';

export const BankAccountDetails = () => {
  const { isAllowed } = useIsViewEditBankAccountAllowed();

  if (!isAllowed) {
    return <Redirect to={routePaths.accessDenied} />;
  }

  return (
    <FormProvider initialState={bankFormDataInitialState}>
      <Switch>
        <Route exact path={routePaths.employeeDetailsV2.bankAccountDetails.preview}>
          <PreviewBankAccount />
        </Route>
        <Route exact path={routePaths.employeeDetailsV2.bankAccountDetails.edit}>
          <AddEditBankAccount />
        </Route>
        <Route exact path={routePaths.employeeDetailsV2.bankAccountDetails.add}>
          <AddEditBankAccount />
        </Route>
      </Switch>
    </FormProvider>
  );
};
